import { HTMLAttributes } from 'react';
import { Flex, SecondaryColor } from 'glints-aries';
import styled from 'styled-components';

export const Alert = styled(Flex)<HTMLAttributes<HTMLDivElement>>`
  border: solid 1px ${SecondaryColor.orange};
  background-color: #fff6e8;
`;
